import { AdjacentType, edgeTypeMatrix } from '@iotv/datamodel';
import { getIconForInstance } from '../../../Iconography';
const debug = process.env.REACT_APP_DEBUG && false;
const suppressedEdgeTypes = [
    edgeTypeMatrix.Customer.Customer.customer_has_subCustomer_typeV.edgeTypeId,
    edgeTypeMatrix.Customer.Customer.customer_has_subCustomer_typeX.edgeTypeId,
    edgeTypeMatrix.Customer.Customer.customer_has_subCustomer_typeY.edgeTypeId,
    edgeTypeMatrix.Customer.Customer.customer_has_subCustomer_typeZ.edgeTypeId,
    edgeTypeMatrix.Customer.Gateway.customer_has_been_allocated_gateways.edgeTypeId,
    edgeTypeMatrix.Customer.Gateway.customer_manages_gateway.edgeTypeId,
    edgeTypeMatrix.Customer.User.customer_has_users.edgeTypeId,
    edgeTypeMatrix.Customer.Device.customer_device_inventory_includes.edgeTypeId,
    edgeTypeMatrix.Customer.Device.customer_has_been_allocated_device.edgeTypeId,
];
/** returns set of  */
export const getMetaModelDerivedPaths = ({ treeNode }) => {
    const paths = [];
    const outVEdgeTypeDefinitionMaps = edgeTypeMatrix[treeNode.type];
    if (outVEdgeTypeDefinitionMaps) {
        for (const [inVType, edgeTypeDefinitionsMap] of Object.entries(outVEdgeTypeDefinitionMaps)) {
            for (const edgeTypeDefinition of Object.values(edgeTypeDefinitionsMap)) {
                if (!suppressedEdgeTypes.includes(edgeTypeDefinition.edgeTypeId)) {
                    const pathstep = {
                        renderTypeFolder: true,
                        stepQuery: {
                            objectTypeId: inVType,
                            edgeTypeId: edgeTypeDefinition.edgeTypeId,
                            adjacencyType: AdjacentType.CHILD,
                            nodeFilters: [],
                        },
                        endIcon: getIconForInstance,
                        /** we use the function version of nextSteps to create a lazy loaded recursive tree, which would not be possible if done statically here due to infinite recursion around types */
                        nextSteps: getMetaModelDerivedPaths,
                    };
                    /** limit outV content of Group to Group of contained type ( or SubGroup ) by contraining getMetaModelDerivedPaths output to supportedTyp*/
                    if (treeNode.type === 'Group') {
                        //  Group has Sub Group and Group has supportedType  support
                        if (typeof pathstep.stepQuery !== 'function' && ['Group', treeNode.supportedType].includes(inVType)) {
                            paths.push(pathstep);
                        }
                        else {
                            //not push unsupported type query
                        }
                    }
                    else {
                        paths.push(pathstep);
                    }
                }
                else {
                    debug && console.log(`Suppressed ${edgeTypeDefinition.edgeTypeId}`);
                }
            }
        }
    }
    else {
        debug && console.log(`${treeNode.type} has no edgeTypeMatrix entries`);
    }
    return paths;
};
